import { jsxs, jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Box } from "@mui/system";
import { memo } from "react";
import { CustomArrowButton } from "./custom-arrow-button.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { CustomArrowButtonDirections } from "../interfaces/custom-arrow-button.interface.es.js";
function CustomNumberSpinnerBuilder({
  onUpArrowClick,
  onDownArrowClick,
  disabled
}) {
  return /* @__PURE__ */ jsxs(Box, { display: Displaying.flex, flexDirection: Direction.column, gap: Spacing["0"], children: [
    /* @__PURE__ */ jsx(CustomArrowButton, { direction: CustomArrowButtonDirections.up, onClick: onUpArrowClick, disabled }),
    /* @__PURE__ */ jsx(CustomArrowButton, { direction: CustomArrowButtonDirections.down, onClick: onDownArrowClick, disabled })
  ] });
}
const CustomNumberSpinner = memo(CustomNumberSpinnerBuilder);
export {
  CustomNumberSpinner
};
//# sourceMappingURL=custom-number-spinner.es.js.map
